import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import Container from '../../templates/Container/Container'
import TabItemEditConfig from './TabItemEditConfig'
import { TabItemModelProps } from './types'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import EditionWrapper from '../../templates/EditionWrapper'
import {
  WithAutomaticTestIdsType,
  withAutomaticTestIds
} from '../../../utils/aem/with-automatic-test-ids'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'

const TabItem = withComponentRefresh(
  withAutomaticTestIds(
    (
      props: WithAutomaticTestIdsType<
        EditableComponentPropsType<TabItemModelProps>
      >
    ) => {
      const {
        id,
        title,
        ariaLabel,
        icon,
        imagePath,
        imageHeight,
        imageWidth,
        imgAlt,
        imageSrcSet,
        ...rest
      } = props.model
      // const { getDataTestIdObject } = props
      const editableProps = useExtractEditableProps(props, rest)

      return (
        <EditableComponent {...editableProps}>
          {TabItemEditConfig.isEmpty(props)
            ? TabItemEditConfig.emptyLabel
            : null}
          {!TabItemEditConfig.isEmpty(props) &&
            (AuthoringUtils.isInEditor() ? (
              <EditionWrapper label={TabItemEditConfig.emptyLabel}>
                <Container {...props} />
              </EditionWrapper>
            ) : null)}
        </EditableComponent>
      )
    }
  )
)

const TabItemWithErrorBoundary = withErrorBoundary(TabItem, {
  componentName: 'TabItem',
  fallback: <ErrorFallback componentName="TabItem" />
})

export default TabItemWithErrorBoundary
